<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ $t("PurchasePlans.autoRuler.add_dialog_title") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-left my-2">
            </v-list-item-title>
            <v-list-item-subtitle>
              <ValidationObserver ref="observer">
<!--              <SearcherDatetime-->
<!--                v-if="type == 1"-->
<!--                class="my-n2 ml-2 pb-1"-->
<!--                v-model="data"-->
<!--                type="minutes"-->
<!--                dense-->
<!--                hide-icon-->
<!--                :minute-step="30"-->
<!--              />-->
                <v-row  v-if="type == 1 || type == 4">
                  <v-col cols="3" md="3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('PurchasePlans.autoRuler.data_time')"
                      :rules="{
                        required:true,
                        regex: '^[0-9]+$',
                        length: 2,
                        min_value: 0,
                        max_value: 23,
                      }"
                    >
                      <v-text-field
                        v-model="data_time"
                        type="number"
                        style="max-width: 50px"
                        :error-messages="errors"
                        :suffix="$t('PurchasePlans.autoRuler.data_time')"
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-row align="center" style="max-width: 20px;">
                    <span>{{ $t("Global.colon") }}</span>
                  </v-row>
                  <v-col cols="3" md="3">
                    <ValidationProvider
                      v-slot="{ errors }"
                      :name="$t('PurchasePlans.autoRuler.data_minute')"
                      :rules="{
                        required:true,
                        regex: {regex: '^[0-9]+$'},
                        length: 2,
                        min_value: 0,
                        max_value: 55,
                        divisibleByFive: (type == 1) ? true :false,
                        divisibleByHalf: (type == 4) ? true :false,
                      }"
                    >
                      <v-text-field
                        v-model="data_minute"
                        type="number"
                        style="max-width: 50px"
                        :error-messages="errors"
                        :suffix="$t('PurchasePlans.autoRuler.data_minute')"
                      >
                        <template v-slot:message="{ key, message }">
                          <div :class="key == 0 ? 'danger--text' : ''">
                            {{ message }}
                          </div>
                        </template>
                      </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              <v-text-field
                v-if="type == 2 || type == 3"
                v-model="data"
                single-line
                :label="type == 2 ? $t('PurchasePlans.autoRuler.sms') : $t('PurchasePlans.autoRuler.emails')"
              ></v-text-field>
              </ValidationObserver>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="submit()">
          {{ $t("PurchasePlans.autoRuler.add_dialog_title") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import {ValidationObserver, ValidationProvider, extend} from "vee-validate";
import i18n from "@/i18n";

extend('divisibleByFive', {
  validate: value => {
    const num = Number(value);
    return num === 0 || num % 5 === 0;
  },
  message: i18n.t('PurchasePlans.autoRuler.data_minute_error')
});

extend('divisibleByHalf', {
  validate: value => {
    const num = Number(value);
    return num === 0 || num === 30;
  },
  message: i18n.t('PurchasePlans.autoRuler.data_minute_error_half')
});

export default {
  name: "AddDialog",

  components: {
    ValidationObserver,
    ValidationProvider,
  },

  props: {
    value: Boolean,
    type: Number,
  },

  computed: {
    // timeQuantumSelect: () => [
    //   {
    //     key: "00:00-01:00",
    //     value: "00:00-01:00",
    //   },
    //   {
    //     key: "01:00-02:00",
    //     value: "01:00-02:00",
    //   },
    //   {
    //     key: "02:00-03:00",
    //     value: "02:00-03:00",
    //   },
    //   {
    //     key: "03:00-04:00",
    //     value: "03:00-04:00",
    //   },
    //   {
    //     key: "04:00-05:00",
    //     value: "04:00-05:00",
    //   },
    //   {
    //     key: "05:00-06:00",
    //     value: "05:00-06:00",
    //   },
    //   {
    //     key: "06:00-07:00",
    //     value: "06:00-07:00",
    //   },
    //   {
    //     key: "07:00-08:00",
    //     value: "07:00-08:00",
    //   },
    //   {
    //     key: "08:00-09:00",
    //     value: "08:00-09:00",
    //   },
    //   {
    //     key: "09:00-10:00",
    //     value: "09:00-10:00",
    //   },
    //   {
    //     key: "10:00-11:00",
    //     value: "10:00-11:00",
    //   },
    //   {
    //     key: "11:00-12:00",
    //     value: "11:00-12:00",
    //   },
    //   {
    //     key: "12:00-13:00",
    //     value: "12:00-13:00",
    //   },
    //   {
    //     key: "13:00-14:00",
    //     value: "13:00-14:00",
    //   },
    //   {
    //     key: "14:00-15:00",
    //     value: "14:00-15:00",
    //   },
    //   {
    //     key: "15:00-16:00",
    //     value: "15:00-16:00",
    //   },
    //   {
    //     key: "16:00-17:00",
    //     value: "16:00-17:00",
    //   },
    //   {
    //     key: "17:00-18:00",
    //     value: "17:00-18:00",
    //   },
    //   {
    //     key: "18:00-19:00",
    //     value: "18:00-19:00",
    //   },
    //   {
    //     key: "19:00-20:00",
    //     value: "19:00-20:00",
    //   },
    //   {
    //     key: "20:00-21:00",
    //     value: "20:00-21:00",
    //   },
    //   {
    //     key: "21:00-22:00",
    //     value: "21:00-22:00",
    //   },
    //   {
    //     key: "22:00-23:00",
    //     value: "22:00-23:00",
    //   },
    //   {
    //     key: "23:00-00:00",
    //     value: "23:00-00:00",
    //   }
    // ],
  },

  data: () => ({
    dialog: false,
    data: null,
    data_time: null,
    data_minute: null,
  }),

  methods: {
    submit() {
      if (this.type != 1 && this.type != 4){
        this.$emit('add', this.data)
      }else {
        this.$refs.observer.validate().then(
          async function (result) {
            if (result) {
              this.$emit('add', (this.data_time) + ':' + (this.data_minute))
            }
          }.bind(this)
        );
      }
    }
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.data = null;
          this.data_time = null;
          this.data_minute = null;
          this.$refs.observer.reset();
        }
        this.$emit("input", this.dialog);
      },
    },
  },
};
</script>